import React, { useState } from "react";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import toast from "react-hot-toast";

const DeletePopup = ({ isOpen, onClose,expenseId,fetchExpenses }) => {

    const [isSubmitting, setIsSubmitting] = useState(false);
  
    const handleStatusUpdate = async () => {
      setIsSubmitting(true);
      try {
        const response = await apiService.delete(`/expenses/${expenseId}`)
          onClose();
          toast.success(response.message, {
            duration: 2000,
          });
          fetchExpenses();

      } catch (errors) {
        handleError(errors);
      } finally {
        setIsSubmitting(true);
      }
    };
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0  flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="w-[350px] bg-white p-8 rounded-xl shadow-lg relative">
        <p className="text-lg font-semibold mb-8 text-center">Are you sure you want to delete this ?</p>
        <div className="flex justify-center gap-4 mt-4">
          <button
            className="px-4 py-2 bg-white text-green rounded-lg border border-green cardtext"
            onClick={onClose}
          >
            Close
          </button>
          <button
            type="submit"
            className={`w-[75px] sm:w-[93px] text-sm text-center py-2 rounded-lg ${isSubmitting
              ? "bg-green50 cursor-not-allowed"
              : "bg-green text-white"
              }`}
            disabled={isSubmitting}
            onClick={handleStatusUpdate}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePopup;
